import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const merchantsService = {
  getAllMerchants,
  getAllMerchantLocations,
  updateLocations,
  addMerchant,
  getMerchant,
  deleteMerchant
};

function getAllMerchants(params) {
  return apiCall("GET", apiUrls.merchants.base, null, params);
}

function getAllMerchantLocations(merchantId, params) {
  return apiCall("GET", `${apiUrls.merchants.base}/${merchantId}/locations`, null, params);
}

function addMerchant(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.merchants.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function updateLocations(locations, merchantId) {
  return apiCall(
    "PUT",
    `${apiUrls.merchants.base}/${merchantId}/locations`,
    locations
  );
}

function getMerchant(id) {
  return apiCall("GET", `${apiUrls.merchants.base}/${id}`);
}

function deleteMerchant(id) {
  return apiCall("DELETE", `${apiUrls.merchants.base}/${id}`);
}
